module.exports = __webpack_public_path__ + "images/FUSA_icons/074-delivery-truck.b54a2f58c0db056fde20cde255fdba51.svg";